import { isUpperCase, isWhitespaceOrEmpty, toLocaleAwareUpperCase } from "./String";
import { LanguageGroup } from "../domain/Language";
import { invert } from "./Map";
function transliterateCharInternal(text, letters, lang) {
    let startPosition = Math.max(text.length - lang.maxLetterLength, 0);
    for (; startPosition < text.length; startPosition++) {
        const key = lang.group != LanguageGroup.Latin && text.length > 1
            ? toTranslit(text.slice(startPosition, -1), lang) + text.slice(-1)
            : text.substring(startPosition);
        const letter = letters.get(key.toLowerCase());
        if (!letter)
            continue;
        const upperCase = isUpperCase(text.charAt(startPosition));
        const newLetter = upperCase ? toLocaleAwareUpperCase(letter, lang) : letter;
        return { newLetter: newLetter, removedTextIndex: startPosition };
    }
    return null;
}
export function transliterateChar(text, lang, translitEnabled) {
    const result = translitEnabled ? transliterateCharInternal(text, lang.alphabet, lang) : null;
    const newLetter = result ? result.newLetter : text.slice(-1);
    const removedTextIndex = result ? result.removedTextIndex : text.length - 1;
    if (newLetter == `"` || newLetter == `'`) {
        const isOpenQuote = isWhitespaceOrEmpty(text.charAt(removedTextIndex - 1));
        const quote = newLetter == `"` ? (isOpenQuote ? "“" : "”") : (isOpenQuote ? "‘" : "’");
        return { newLetter: quote, removedTextIndex: removedTextIndex };
    }
    return result;
}
function toTranslitInternal(text, letters) {
    let result = "";
    for (let index = 0; index < text.length; index++) {
        const character = text.charAt(index);
        const transliteration = letters.get(character.toLowerCase());
        if (transliteration == null) {
            result += character;
            continue;
        }
        result += isUpperCase(character) ? uppercaseFirstChar(transliteration) : transliteration;
    }
    return result;
}
function uppercaseFirstChar(string) {
    return string.charAt(0).toUpperCase() + string.substring(1);
}
export function transliterateString(text, lang) {
    let result = "";
    let index = text.length;
    while (index > 0) {
        const translitResult = transliterateCharInternal(text.slice(0, index), lang.alphabet, lang);
        if (translitResult == null) {
            result = text.charAt(index - 1) + result;
            index--;
            continue;
        }
        result = translitResult.newLetter + result;
        index = translitResult.removedTextIndex;
    }
    return result;
}
export function toTranslit(text, lang) {
    return toTranslitInternal(text, invert(lang.alphabet));
}
